import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { TitleService } from '../../Services/title.service';
import { MatDialog } from '@angular/material/dialog';
import { DocType } from 'src/app/job-seeker/Models/constant';
import { firstValueFrom } from 'rxjs';
import { JobSeekerService } from 'src/app/job-seeker/Services/job-seeker.service';
import { MediaConstant } from 'src/app/job-seeker/Models/constant';
import { StorageService } from '../../Services/storage.service';

@Component({
  selector: 'app-doc-upload-list',
  templateUrl: './doc-upload-list.component.html',
  styleUrls: ['./doc-upload-list.component.css']
})
export class DocUploadListComponent {
  @Input() data: any;
  @Output() deleteItem = new EventEmitter<number>();
  @Output() IsDeleteAction = new EventEmitter<boolean>();
  @Input() isDeleteAction: boolean=true;
  @Input() isDownload: boolean=true;
  docs: any;
  docId: any;
  Type: any;
  mediaConstant: any;
  isLogin=false;
  constructor(
    private titleService: TitleService,
    private Diloge: MatDialog,
    private jobSeekerService: JobSeekerService, private storageService:StorageService
  ) {
    this.isLogin = this.storageService.isLoggedIn();
    this.Type = DocType.Other;
    this.mediaConstant = MediaConstant;
    // this.titleService.setTitle('Job Seeker');
  }

  async getMediaOnLoad(ImageName: any, Type: any, i: any) {
    const mediaModel = {
      ImageName: ImageName,
      Type: Type
    };
    try {
      const res: any = await firstValueFrom(this.jobSeekerService.getMedia(mediaModel));
      if (res.succeeded) {
        this.data[i].file = res.data;
      }
    } catch (error) {

    }
  }

  async downloadDocument(item: any, i: any): Promise<void> {
    if (!item.file) {
      try {
        await this.getMediaOnLoad(item.docName, this.mediaConstant.Image, i);
      } catch (error) {
        console.error('Failed to load media:', error);
        return;
      }
    }

    if (!item.file || !item.docName) {
      console.error('Invalid file or document name.');
      return;
    }

    const link = document.createElement('a');
    link.href = item.file;
    link.download = item.docName;

    if (!link.href.startsWith('data:') && !link.href.startsWith(window.location.origin)) {
      console.warn('Cross-origin download detected, redirecting to the file URL.');
      window.open(item.file, '_blank');
      return;
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  deletePopUp(index:number,doc:any) {
    this.IsDeleteAction.emit(true);
    const dialogRef = this.Diloge.open(DialogeComponent, {
      width: '30%',
      maxHeight: '90%',
      panelClass: 'modal-matdelete',
      data: { "title": `Delete Document : ${doc.docInfo}`, "prefix":"Are you sure you want to delete?"},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((data: { event: string; }) => {
      this.IsDeleteAction.emit(false);
      if (data.event == 'Yes') {
        if(doc.docsId && doc.docsId>0)
        {
          this.deleteItem.emit(doc.docsId);
        }
        else if(doc.supDocId && doc.supDocId>0)
        {
          this.deleteItem.emit(doc.supDocId);
        }
      }
    })
  }
}
